import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, NgForm, AbstractControl, NgModel } from '@angular/forms';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime';
import { parseNumber } from '@telerik/kendo-intl';

import { RvrsService, searchPointData, RIAHelper } from '../../../../core';
import { RvrsSearchPointModalComponent } from './rvrs-search-point-modal/rvrs-search-point-modal.component';
import { ConfirmDialogComponent } from '../../../../common/component/confirm-dialog/confirm-dialog.component';
import { AddDaysToDate, RaService, MsgResult } from '../../../../core';
import { CreateFromStandardAudit } from '../../../../core/models/CreateFromStandardAudit-model';
import { KeywordManager } from '../../../../core/keyword-manager';
import { CreateReverseAudit } from 'app/core/models/CreateReverseAudit';


interface Notification { id: string, name: string, isDefault: boolean };

@Component({
  selector: 'app-rvrs-create-step3',
  templateUrl: './rvrs-create-step3.component.html',
  styleUrls: ['./rvrs-create-step3.component.scss']
})
export class RvrsCreateStep3Component implements OnInit {

  @ViewChild(RvrsSearchPointModalComponent, { static: true }) searchPointModal;
  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog: ConfirmDialogComponent
  _searchRadiusMiles:number = 20;
  get searchRadiusMiles():number{
    return this._searchRadiusMiles;
  }
  set searchRadiusMiles(val:number){
    if(val && !Number.isNaN(val) && val>=1 && val<=20){
      this._searchRadiusMiles = val;
    }
  }
  blockDelete(event):boolean{
    if(event.key == "Delete" || event.key == "Backspace"){
      event.stopPropagation();
      return false;
    }
    return true;
  }

  viewResult: GridDataResult;
  state: State = {
    skip: 0,
    take: 5,
    sort: []
  };
  sorted: string = "";
  norecords: boolean = true;

  get invalidKeyword(): boolean {
    let keywordManager = new KeywordManager();
    let cleanedKeyword = keywordManager.CleanNoise(this.keywordToAdd.trim().toUpperCase());
    return cleanedKeyword == "" ;
  }
  keywordToAdd: string = "";
  originalKeywordList: string;

  addKeyordClick() {
    let keywordManager = new KeywordManager();
    let kw = this.keywordToAdd.trim().toUpperCase();
    kw = keywordManager.CleanNoise(kw);
    if(kw && kw!="")
      this.keywordList.push({ textContent: kw });
    this.keywordToAdd = "";
  }
  deleteKeyword(event) {
    const idx = this.keywordList.findIndex(keyword => keyword === event.item);
    this.keywordList.splice(idx, 1);
  };
  keywordList: {
    textContent: string,
    [key: string]: any
  }[] = [];

  selectedAudit: string = "";
  initialDateOfStay: Date;

  earliestRunDate: Date;
  auditDate: Date;
  minAuditDate: Date;
  maxAuditDate: Date;
  runAuditNow: boolean;
  scheduledTime: Date;
  lastRunDate: Date;
  importedData: CreateFromStandardAudit = new CreateFromStandardAudit();
  dataToSave: CreateReverseAudit = new CreateReverseAudit();

  disableAuditAmadeus: boolean = false;
  disableAuditApollo: boolean = false;
  disableAuditGalileo: boolean = false;
  disableAuditSabre: boolean = false;
  disableAuditWorldspan: boolean = false;

  constructor(private service: RvrsService) {
    this.runAuditNow = true;
    const scheduled = AddDaysToDate(this.now(), 1);
    this.initialDateOfStay = AddDaysToDate(this.now(), 30).toJsDate();
    this.minAuditDate = scheduled.toJsDate();
    this.maxAuditDate = AddDaysToDate(this.now(), 330).toJsDate();
    //this.scheduledDate = scheduled.toJsDate();
    this.scheduledTime = scheduled.addHours(7).toJsDate();

    this.earliestRunDate = this.now().date.toJsDate();
    this.lastRunDate = this.maxAuditDate;

  }

  ngOnInit() {
    this.viewResult = { data: this.dataToSave.SearchPoints, total: this.dataToSave.SearchPoints.length };
  }
  now: () => DateTime = () => DateTime.now;

  updateData(importedData: CreateFromStandardAudit, dataToSave: CreateReverseAudit) {
    this.importedData = importedData;
    this.dataToSave = dataToSave;
    this.dataToSave.DateChecked = RIAHelper.BuildWsDateFromDateForRateAvail(this.initialDateOfStay);
    this.disableAuditAmadeus = !importedData.AuditAmadeus;
    this.disableAuditApollo = !importedData.AuditApollo;
    this.disableAuditGalileo = !importedData.AuditGalileo;
    this.disableAuditSabre = !importedData.AuditSabre;
    this.disableAuditWorldspan = !importedData.AuditWorldspan;
    this.originalKeywordList = importedData.RACFilters;
    const keywordManager = new KeywordManager();
    keywordManager.BreakdownList(importedData.RACFilters);
    this.keywordList = keywordManager.Keywords.map(d => { return { textContent: d } });
    this.notificationTemplateList = importedData.NotificationTemplates ? (importedData.NotificationTemplates.map(d => { return { id: d.TemplateIdGuid, name: d.Name, isDefault: d.IsDefault }; })) : [];
    this.dataToSave.DateChecked = RIAHelper.BuildWsDateFromDateForRateAvail(this.initialDateOfStay);
    this.dataToSave.SabrePCC = importedData.SabrePCC;
    this.viewResult = { data: this.dataToSave.SearchPoints, total: this.dataToSave.SearchPoints.length };

  }
  pageChange(event: PageChangeEvent): void {

    this.state.skip = event.skip;
    //kendo will call dataStateChange() not needed=> this.loadItems();
  }
  dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.refreshSearchPointsGrid();
  }
  refreshSearchPointsGrid() {
    let state = this.state;
    this.sorted = "";
    //this.selectedID=[];
    this.sorted = (state.sort.find(e => e.dir === 'asc' || e.dir == 'desc') || { 'field': '' }).field;
    let data = this.dataToSave.SearchPoints;
    this.norecords = data.length ? false : true;
    if (state.sort && state.sort.length > 0) {
      let srt = state.sort[0];
      let srtFn = this.dynamicSort(srt.field, srt.dir);
      data = data.sort(srtFn);
    }
    if (this.state.skip >= data.length) {
      this.state.skip = data.length - this.state.take;
      this.state.skip = this.state.skip < 0 ? 0 : this.state.skip;
    }
    let pageDate = data.slice(this.state.skip, this.state.skip + this.state.take);
    this.viewResult = {
      data: pageDate,
      total: data.length
    };

  }
  public dynamicSort<T>(property: string, dir: string): (a: T, b: T) => number {
    let sortOrder = (dir === "desc") ? -1 : 1;
    return (a, b) => {
      let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  onDateOfStayChange(event) {
    let nextVal: Date = new Date(this.initialDateOfStay);
    if (event) {
      let dateTime: Date = event as Date;
      if (dateTime) {
        if ((dateTime >= this.minAuditDate && dateTime <= AddDaysToDate(new DateTime(this.maxAuditDate, DateTime.Kind.Local), 1).toJsDate())
          && (dateTime >= this.scheduledTime)) {
          nextVal = event;
        }
      }
    }
    this.initialDateOfStay = nextVal;
    this.dataToSave.DateChecked = RIAHelper.BuildWsDateFromDateForRateAvail(nextVal);;
  }

  AddSearchPoints(event) {
    var ditems: DataTransferItemList = event.clipboardData.items;
    var items = Array.from(ditems);
    if (items && items.length > 0) {
      var textItem: DataTransferItem = items.find(m => m.type == "text/plain");
      var text = textItem.getAsString((data) => {

        var rows = data.split('\r\n');
        rows.forEach(rowStr => {
          var cols = rowStr.split('\t');
          if (cols.length == 5) {
            let name = cols[0].trim().substr(0, 255);
            let latitude = parseNumber(cols[1]);
            let longitude = parseNumber(cols[2]);
            let PropertyAddress = cols[3].trim().substr(0, 255);
            let Radius = parseNumber(cols[4]);
            if (name.length > 0 && !Number.isNaN(latitude) && !Number.isNaN(longitude) && !Number.isNaN(Radius)
              && PropertyAddress.length > 0) {
              this.dataToSave.SearchPoints.push({
                Type: 2,
                Name: name,
                PropertyAddress: PropertyAddress,
                Latitude: latitude,
                Longitude: longitude,
                Radiuskm: Radius * 1.6093472,
                Radius: Radius,
              });
            }
          }
        });
        this.refreshSearchPointsGrid();
      });
    }
  }

  getSelectedAudit() {
    return this.selectedAudit;
  }

  onRunNowClick(enable: boolean) {
    this.runAuditNow = enable;
    this.updateMinAuditDate();
  }

  onEnableNotifications(event) {
    this.dataToSave.SendNotifications = !this.dataToSave.SendNotifications;
  }

  updateScheduledTime(event) {
    let nextVal: Date = new Date(this.scheduledTime);
    if (event) {
      let dateTime: Date = event as Date;
      if (dateTime) {
        if (dateTime >= this.earliestRunDate && dateTime <= AddDaysToDate(new DateTime(this.lastRunDate, DateTime.Kind.Local), 1).toJsDate()) {
          nextVal = event;
        }
      }
    }
    this.scheduledTime = nextVal;
    this.updateMinAuditDate();
  }

  updateMinAuditDate() {
    let min = AddDaysToDate(this.now(), 1).toJsDate();
    if (!this.runAuditNow && this.scheduledTime > min) {
      min = AddDaysToDate(new DateTime(this.scheduledTime), 1).toJsDate();
      if (min > this.maxAuditDate)
        min = this.maxAuditDate;
    }
    this.minAuditDate = min;
  }

  dropdownPopupSettings: string;
  _notificationTemplateList: Notification[] = [];
  set notificationTemplateList(data: Notification[]) {
    this._notificationTemplateList = data;
    if (data.length > 0) {
      this.notificationSelection = data[0].id;
      let dfault = data.filter(q => q.isDefault ? true : false);
      if (dfault.length > 0) {
        this.notificationSelection = dfault[0].id;
      }
    } else {
      this.notificationSelection = null;
    }

  }
  notificationSelection: string = null;//"Failed Audit Template";
  showSearchPointModal(event) {

    this.searchPointModal.init(this.searchRadiusMiles);
    this.searchPointModal.showModal = true;
  }

  addSearchPoint(searchPoint: searchPointData) {
    this.dataToSave.SearchPoints.push(searchPoint);
    this.refreshSearchPointsGrid();
  }
  removeRow(rowIndex) {
    this.dataToSave.SearchPoints.splice(rowIndex, 1);
    this.refreshSearchPointsGrid();
  }


  Validated(): boolean {
    this.PreprocessData();
    let data = this.dataToSave;
    let validations = [
      { test: () => !(data.AuditAmadeus || data.AuditApollo || data.AuditGalileo || data.AuditSabre || data.AuditWorldspan), message: "Select a GDS" },
      { test: () => !(data.AuditID || data.AuditID == "00000000-0000-0000-0000-000000000000"), message: "Missing Rate Audit ID " },
      { test: () => !(data.CustomerAccountID) || (data.CustomerAccountID == ""), message: "Account ID is required" },
      { test: () => !(data.CustomerAccountName) || (data.CustomerAccountName == ""), message: "Account Name is required" },
      { test: () => !(data.SearchPoints) || (data.SearchPoints.length == 0), message: "At least on search point is needed" },
      { test: () => !(data.DateChecked == RIAHelper.BuildWsDateFromDateForRateAvail(this.initialDateOfStay)), message: "Date of stay is out of sync" },
      { test: () => !(data.DateChecked) || (this.initialDateOfStay < this.minAuditDate || this.initialDateOfStay > this.maxAuditDate), message: "Invalid Date of stay" },
      { test: () => (this.initialDateOfStay < data.ScheduledRunDate), message: "Date of stay is not valid for the current run date" },
      { test: () => (data.SendNotifications && (!data.NotificationTemplateID || data.NotificationTemplateID == "" || data.NotificationTemplateID == "00000000-0000-0000-0000-000000000000")), message: "Select a Notification Template" },
      { test: () => (data.RACFilters) && (data.RACFilters.length > 1000), message: "Resulting Rate Access Code Filters string exceeds 1000 characters." },
      { test: () => (data.RACFilters=="\"\""), message: "You must provide at least one keyword to process." },
    ];
    var errors = validations.filter((validation) =>
      validation.test()
    )
      .map(validation => validation.message);
    if (errors.length > 0) {
      this.confirmDialog.confirm("One or more items need attention.", errors.join("\r\n"), "Validation").subscribe();
      return false;
    }
    return true;
  }

  PreprocessData() {
    const keywordManager = new KeywordManager();
    this.dataToSave.RACFilters = this.keywordList.map(d => '"' + d.textContent + '"').join(",");
    keywordManager.BreakdownList(this.dataToSave.RACFilters);
    this.dataToSave.RACFilters = keywordManager.GetCommaList();
    this.dataToSave.CustomerAccountID = this.dataToSave.CustomerAccountID.trim();
    this.dataToSave.CustomerAccountName = this.dataToSave.CustomerAccountName.trim();
    this.dataToSave.NotificationTemplateID = this.dataToSave.SendNotifications ? this.notificationSelection : "00000000-0000-0000-0000-000000000000";
    this.dataToSave.PropertyIDs = this.importedData.Properties.filter(p => p.IsChecked).map(p => p.AuditPropertyID);
    this.dataToSave.ScheduledRunDate = this.runAuditNow ? this.now().toJsDate() : this.scheduledTime;
  }
}






